import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CustomerLogin = () => {
  const [formData, setFormData] = useState({ 
    customer_id: '', 
    password: '' 
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('https://infrec.in/php-backend/backend/user/customerlogin.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customer_id: formData.customer_id,
          password: formData.password
        })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        const customerData = {
          id: data.customer.id,
          name: data.customer.name,
          email: data.customer.email,
          mobile: data.customer.mobile,
          customer_id: data.customer.customer_id,
          date_of_birth: data.customer.date_of_birth || '',
          address: data.customer.address || '',
          password: data.customer.password,
          created_at: data.customer.created_at
        };
        
        sessionStorage.setItem('token', data.token);
        sessionStorage.setItem('customerData', JSON.stringify(customerData));
        
        alert('Login successful!');
        navigate('/customer-profile');
      } else {
        setError(data.message || 'Invalid credentials');
        alert(data.message || 'Invalid credentials');
      }
    } catch (error) {
      console.error('Login Error:', error);
      setError(`Error during login: ${error.message}`);
      alert(`Error during login: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-3xl font-bold text-center mb-6 text-darkBlue">Customer Login</h2>
        
       
        {/* Error Message */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
            <p className="text-sm text-red-800">{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Customer ID</label>
            <input
              type="text"
              name="customer_id"
              value={formData.customer_id}
              onChange={handleChange}
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter your customer id"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 font-medium mb-2">Password</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 pr-16"
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-3 text-sm text-blue-600 hover:text-blue-800 font-semibold"
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>
          <div className="flex gap-2 justify-center">
            <button
              type="submit"
              disabled={loading}
              className="flex-1 max-w-xs bg-darkBlue text-white p-3 rounded-lg font-semibold hover:bg-blue-700 disabled:bg-gray-400"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
            <button
              type="button"
              onClick={() => setFormData({ customer_id: '', password: '' })}
              disabled={loading}
              className="flex-1 max-w-xs bg-gray-600 text-white p-3 rounded-lg font-semibold hover:bg-gray-700 disabled:bg-gray-400"
            >
              Clear
            </button>
          </div>
        </form>

        <p className="text-center mt-4 text-gray-600">
          <a href="/customer-forgot-password" className="text-blue-600 hover:underline">Forgot Password?</a>
        </p>
        <p className="text-center mt-2 text-gray-600">
          Don't have an account? <a href="/customer-signup" className="text-blue-600 hover:underline">Sign Up</a>
        </p>
      </div>
    </div>
  );
};

export default CustomerLogin;
